import { render, staticRenderFns } from "./AnalisiRischiThViewComponent.vue?vue&type=template&id=317c8dd6&scoped=true"
import script from "./AnalisiRischiThViewComponent.vue?vue&type=script&lang=js"
export * from "./AnalisiRischiThViewComponent.vue?vue&type=script&lang=js"
import style0 from "./AnalisiRischiThViewComponent.vue?vue&type=style&index=0&id=317c8dd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "317c8dd6",
  null
  
)

export default component.exports